import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnterForgetForm.styl';


Vue.component('BXmakerAuthuserphoneEnterForgetForm', {
    name: 'BXmakerAuthuserphoneEnterForgetForm',
    data() {
        return {};
    },
    computed: {},
    methods: {
        onClickConfirm() {
            if (this.$root.isFullCaptcha) {
                this.$root.forget();
            }
        },
        onChangePhone(data){
            this.$root.setPhone(data.formattedValue);
        },
        onEnterPhone() {
            this.onClickConfirm();
        },
        onEnterEmail() {
            this.onClickConfirm();
        },
    },
    template: `
            <div class="bxmaker-authuserphone-enter-forget-form"  >
                 
                 <slot name="message" />  
                        <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error" />
                   </slot>     
                                      
                    <slot name="phone">       
                    
                     <BXmakerAuthuserphoneInputPhone  v-if="$root.isEnabledPhoneMask"
                            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_FORGET_FORM_PHONE" 
                            :value="$root.phone" 
                            @onChange="onChangePhone" 
                            @onEnter="onEnterPhone" 
                            name="PHONE" 
                            :defaultCountry="$root.phoneMaskDefaultCountry"
                            :countryTopList="$root.phoneMaskCountryTopList"                          
                        />
                                                
                                
                        <BXmakerAuthuserphoneInput v-else
                            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_FORGET_FORM_PHONE" 
                            :value="$root.phone" 
                            @onInput="$root.setPhone" 
                             @onEnter="onEnterPhone"                          
                            name="PHONE" 
                        />
                        
                    </slot>     
                    
                                                   
                    <slot name="email" v-if="$root.isEnabledRestoreByEmail">  
                    
                         <div class="bxmaker-authuserphone-enter-forget-form__or" >
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_FORGET_FORM_OR}}
                        </div>
                                     
                        <BXmakerAuthuserphoneInput                             
                            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_FORGET_FORM_EMAIL" 
                            :value="$root.email" 
                            @onInput="$root.setEmail" 
                             @onEnter="onEnterEmail"  
                            name="EMAIL" 
                        />
                    </slot>        
                    
                   <slot name="captcha">
                        <BXmakerAuthuserphoneCaptcha 
                            :code="$root.captchaCode"
                            :src="$root.captchaSrc"
                            :length="$root.captchaLength"
                            :loader="$root.captchaLoader"
                            @onInput="$root.setCaptchaCode"
                            @onComplete="onClickConfirm"
                            @onRefresh="$root.refreshCaptcha"
                           />  
                     </slot>   
                     
                    
                     <slot name="request">
                        <BXmakerAuthuserphoneButton 
                            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_FORGET_FORM_BUTTON"  
                            :loader="$root.forgetLoader"
                            @onClick="onClickConfirm" 
                        />
                    </slot>
                   
                             
            </div>
        `,
});